import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';

import AgentPortalError from 'errors/AgentPortalError';

import { TIMETABLE_BANNER_NEWS } from 'store/queries';

/**
 * Hook to lazily fetch timetable banner news
 * @returns {LazyTimetableBannerNewsQueryResult}
 * @throws {AgentPortalError} - Throws an error if the query fails
 */
export const useLazyTimetableBannerNewsQuery = () => {
  const [timetableBannerNewsQuery, { data, error, loading, called }] = useLazyQuery(TIMETABLE_BANNER_NEWS);
  const timetableBannerNews = data?.timetableBannerNews;

  const lazyTimetableServiceQuery = useCallback(
    ({ market }) => {
      timetableBannerNewsQuery({ variables: { market } });
    },
    [timetableBannerNewsQuery]
  );

  if (error) {
    throw new AgentPortalError(error);
  }

  return [lazyTimetableServiceQuery, { timetableBannerNews, called, loading }];
};

export default useLazyTimetableBannerNewsQuery;
